var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-secondary",attrs:{"id":"app"}},[_c('div',{staticClass:"alert",attrs:{"role":"alert","id":"snackbar_home"}},[_vm._v(" WELCOME MANHOLE 4 AFRICA PRODUCTION MONITORING. ")]),(!_vm.auth && _vm.isPublicRoute)?_c('router-view'):(!_vm.auth)?_c('LogIn'):_vm._e(),(_vm.auth)?_c('Nav'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }